import { MaterialChemistry } from "src/store/api/generatedApi";
import { MaterialOverrideRow } from "./types";
import { useCallback } from "react";

export const useMaterialChemistryEdits = (
  setMaterialChemistryOverrides: (
    update: (current: MaterialChemistry[]) => MaterialChemistry[]
  ) => void
) => {
  const handleUpdateItem = useCallback(
    (
      newRow: MaterialOverrideRow,
      oldRow: MaterialOverrideRow
    ): MaterialOverrideRow => {
      if (newRow.loc !== oldRow.loc || newRow.scale !== oldRow.scale) {
        const validatedNewItem: MaterialChemistry = {
          material_id: newRow.material_id,
          chemical_element_id: newRow.chemical_element_id,
          loc: newRow.loc,
          scale: newRow.scale,
        };

        setMaterialChemistryOverrides((current) => [
          ...current.filter(
            (item) =>
              !(
                item.material_id === validatedNewItem.material_id &&
                item.chemical_element_id ===
                  validatedNewItem.chemical_element_id
              )
          ),
          validatedNewItem,
        ]);

        return {
          ...validatedNewItem,
          material_name: newRow.material_name,
          chemical_element_name: newRow.chemical_element_name,
          is_overridden: true,
          is_loc_overridden:
            newRow.loc !== oldRow.loc || newRow.is_loc_overridden,
          is_scale_overridden:
            newRow.scale !== oldRow.scale || newRow.is_scale_overridden,
        };
      } else {
        return oldRow;
      }
    },
    [setMaterialChemistryOverrides]
  );

  const handleDeleteItem = useCallback(
    (row: MaterialOverrideRow) => {
      setMaterialChemistryOverrides((current) =>
        current.filter(
          (item) =>
            !(
              item.material_id === row.material_id &&
              item.chemical_element_id === row.chemical_element_id
            )
        )
      );
    },
    [setMaterialChemistryOverrides]
  );

  const handleAddNewItem = useCallback(
    (
      materialId: number,
      chemicalElementId: number,
      loc: number,
      scale: number
    ) => {
      const newItem: MaterialChemistry = {
        material_id: materialId,
        chemical_element_id: chemicalElementId,
        loc,
        scale,
      };

      setMaterialChemistryOverrides((current) => [
        ...current.filter(
          (item) =>
            !(
              item.material_id === newItem.material_id &&
              item.chemical_element_id === newItem.chemical_element_id
            )
        ),
        newItem,
      ]);
    },
    [setMaterialChemistryOverrides]
  );

  return { handleUpdateItem, handleDeleteItem, handleAddNewItem };
};
